/**
 * A rule holds ONE list selection (14/10/2026): once it has one, the
 * "+ condition" menu's lists item edits it instead of adding a second.
 * For Media Devoted | Created By Ciro Autiero
 */
export function listsMenuLabel(selected: { listIds: number[] } | undefined): { label: string; desc: string } {
  if (!selected) return { label: 'Select lists…', desc: 'search and choose specific lists' };
  const n = selected.listIds.length;
  return { label: 'Edit selected lists…', desc: `${n} chosen — add or remove lists` };
}
